import { render, staticRenderFns } from "./LayananSuperior.vue?vue&type=template&id=58b92a08&scoped=true"
import script from "./LayananSuperior.vue?vue&type=script&setup=true&lang=js"
export * from "./LayananSuperior.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LayananSuperior.vue?vue&type=style&index=0&id=58b92a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b92a08",
  null
  
)

export default component.exports